module.exports = __webpack_public_path__ + "components/home-header/static/header-3--small@2x-34f3091f5ab5e5f9cf991f231ca9b5aa.jpg";